export const BASE_API_PATH = process.env.VUE_APP_BASE_API_PATH || '/api'
